import { gql } from '@apollo/client';

export default gql`
  mutation updateDocEntryStatus(
    $docId: String
    $stepId: Int
    $stepName: String
    $stepNameAr: String
    $stepDesc: String
    $stepColor: String
  ) {
    updateDocEntryStatus(
      docId: $docId
      stepId: $stepId
      stepName: $stepName
      stepNameAr: $stepNameAr
      stepDesc: $stepDesc
      stepColor: $stepColor
    ) {
      ok
      message
      data
      error
    }
  }
`;
